import { getTokenFromLocalStorage } from "../utils/local-storage";

export default getTokenFromLocalStorage;
